export const RTL_WARNING_BANNER_DISMISSED_STORAGE_KEY =
  'rtl_warning_banner_dismissed';
